<template>
  <div>
    <!-- ROW 1 -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full mx-auto self-center">
        <dimming-filter @selectedModem="getData" @disableSave="changeSave"></dimming-filter>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="shadow-md">
          <h5 class="text-center mb-base">Set Dimming Policy To 50%</h5>
          <div class="vx-row mb-4">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <p>On Time:</p>
              <datetime
                type="time"
                value-zone="Asia/Kolkata"
                @input="checkTimeValidation('step1', 'on1')"
                input-class="vs-inputx vs-input--input normal"
                v-model="step1.on"
              ></datetime>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 flex justify-center">
              <vs-avatar size="70px" color="#26302a" text-color="rgb(246, 190, 16)" :text="'S1'" />
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <p>Off Time:</p>
              <datetime
                type="time"
                value-zone="Asia/Kolkata"
                @input="checkTimeValidation('step1', 'off1')"
                input-class="vs-inputx vs-input--input normal"
                v-model="step1.off"
              ></datetime>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="shadow-md">
          <h5 class="text-center mb-base">Set Dimming Policy To 100%</h5>
          <div class="vx-row mb-4">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <p>On Time:</p>
              <datetime
                type="time"
                value-zone="Asia/Kolkata"
                @input="checkTimeValidation('step2')"
                input-class="vs-inputx vs-input--input normal"
                v-model="step2.on"
              ></datetime>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 flex justify-center">
              <vs-avatar size="70px" color="#26302a" text-color="rgb(16, 138, 246)" :text="'S2'" />
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
              <p>Off Time:</p>
              <datetime
                type="time"
                value-zone="Asia/Kolkata"
                @input="checkTimeValidation('step2')"
                input-class="vs-inputx vs-input--input normal"
                v-model="step2.off"
              ></datetime>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mx-auto items-center self-center justify-center flex">
        <vs-button
          class="m-2"
          color="success"
          size="large"
          icon-pack="feather"
          icon="icon-save"
          type="gradient"
          :disabled="checkInput"
          @click="setDimmingPolicy()"
        >{{ buttonText }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import moment from "moment-timezone";
import { functions } from "firebase";
export default {
  data() {
    return {
      modemId: "",
      buttonText: "Save",
      showRest: false,
      endpoint: this.$store.state.endpoint2,
      allInputValidated: false,
      step1: { on: "", off: "", deletable: false },
      step2: { on: "", off: "", deletable: false }
    };
  },
  computed: {
    checkInput() {
      if (this.modemId == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  components: { datetime: Datetime },
  created() {},
  methods: {
    getData(modemId) {
      var self = this;
      this.modemId = modemId;
      var payload = {
        modemid: Number(modemId)
      };
      this.$http.post(this.endpoint + "/api/user_config/read", payload).then(
        response => {
          var response = response.data;
          var scheduleData = response.schedule;
          function pushToArray(Time, setName) {
            //time conversion code
            function getTimeFromMins(mins) {
              if (mins >= 24 * 60 || mins < 0) {
                throw new RangeError(
                  "Valid input should be greater than or equal to 0 and less than 1440."
                );
              }
              var h = (mins / 60) | 0,
                m = mins % 60 | 0;
              var minValue = moment
                .utc()
                .hours(h)
                .minutes(m)
                .format("HH:mm:ss.SSS");
              var dateVal = moment().format("YYYY-MM-DDT");
              return dateVal + minValue + "+05:30";
            }

            //looping through the values
            var onTime = "";
            var offTime = "";
            if (setName == "step1") {
              if (Time[0] == 0) {
                onTime = Time[0];
              } else {
                onTime = Time[0];
              }

              if (Time[1] == 0) {
                offTime = Time[1];
              } else {
                offTime = Time[1];
              }

              self.step1.on = getTimeFromMins(onTime);
              self.step1.off = getTimeFromMins(offTime);
            } else {
              if (Time[0] == 0) {
                onTime = Time[0];
              } else {
                onTime = Time[0];
              }

              if (Time[1] == 0) {
                offTime = Time[1];
              } else {
                offTime = Time[1];
              }

              self.step2.on = getTimeFromMins(onTime);
              self.step2.off = getTimeFromMins(offTime);
            }
            //for (var m in Time) {
            //   console.log(Time[m]);
            //   if (setName == "step1") {

            //     if (m % 2 == 0) {
            //       if (Time[m] == 0) {
            //         onTime = Time[m];
            //       } else {
            //         onTime = Time[m] + 1;
            //       }
            //     }
            //     if (m % 2 == 1) {
            //       if (Time[m] == 0) {
            //         self.step1.push({
            //           on: getTimeFromMins(onTime),
            //           off: getTimeFromMins(Time[m]),
            //           deletable: false
            //         });
            //       } else {
            //         self.step1.push({
            //           on: getTimeFromMins(onTime),
            //           off: getTimeFromMins(Time[m] + 1),
            //           deletable: false
            //         });
            //       }
            //     }
            //   } else {
            //     if (m % 2 == 0) {
            //       if (Time[m] == 0) {
            //         onTime = Time[m];
            //       } else {
            //         onTime = Time[m] + 1;
            //       }
            //     }
            //     if (m % 2 == 1) {
            //       if (Time[m] == 0) {
            //         self.step2.push({
            //           on: getTimeFromMins(onTime),
            //           off: getTimeFromMins(Time[m]),
            //           deletable: false
            //         });
            //       } else {
            //         self.step2.push({
            //           on: getTimeFromMins(onTime),
            //           off: getTimeFromMins(Time[m] + 1),
            //           deletable: false
            //         });
            //       }
            //     }
            //   }
            //}
          }
          if (response != "") {
            self.buttonText = "Update";
            if (scheduleData.relay1.length > 0) {
              self.step1 = {};
              self.step2 = {};
              console.log("calling inner function");
              pushToArray(scheduleData.relay1, "step1");
              pushToArray(scheduleData.relay3, "step2");
            }
          } else {
            self.buttonText = "Save";
            this.setDefaultValue();
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    changeSave(value) {
      if (value) {
        this.modemId = "";
        this.buttonText = "Save";
        this.setDefaultValue();
      }
    },
    setDefaultValue() {
      (this.step1 = { on: "", off: "", deletable: false }),
        (this.step2 = { on: "", off: "", deletable: false });
    },
    checkTimeValidation(stepName) {
      var globalnewArrList = [];
      var self = this;
      var validated = true;
      var onTime1 = "";
      var offTime1 = "";
      if (stepName == "step1") {
        globalnewArrList = this.step1;
        setTime();
      } else {
        globalnewArrList = this.step2;
        setTime();
      }

      function convertToMinutes(time) {
        var minuteTime = time;
        minuteTime = moment.tz(minuteTime, "Asia/Kolkata").format("HH:mm");
        minuteTime = moment
          .duration(minuteTime)
          .asMinutes()
          .toString();
        minuteTime = Number(minuteTime);
        return minuteTime;
      }
      function setTime() {
        onTime1 = convertToMinutes(globalnewArrList.on);
        offTime1 = convertToMinutes(globalnewArrList.off);
        checkOn1();
      }
      function checkOn1() {
        if (onTime1 != 0) {
          if (onTime1 == offTime1) {
            self.$vs.notify({
              title: "Invalid Input",
              time: 10000,
              text: "On time and Off time can not be same in a Set",
              iconPack: "feather",
              icon: "icon-alert-triangle",
              color: "danger"
            });
            validated = false;
          }
        }
      }

      return validated;
    },
    setDimmingPolicy() {
      var validateStep1 = this.checkTimeValidation("step1");
      var validateStep2 = this.checkTimeValidation("step2");
      if (validateStep1 == false) return;
      if (validateStep2 == false) return;
      var step1Data = this.step1;
      var step2Data = this.step2;
      var Relay1 = [];
      var Relay2 = [];

      function pushDataSet(stepData, stepName) {
        var onTime1 = stepData.on;
        var offTime1 = stepData.off;

        if (onTime1.length > 5) {
          onTime1 = moment.tz(onTime1, "Asia/Kolkata").format("HH:mm");
          onTime1 = moment
            .duration(onTime1)
            .asMinutes()
            .toString();
          onTime1 = Number(onTime1);
          if (onTime1 > 0) {
            onTime1 = onTime1;
          } else {
            onTime1 = onTime1;
          }
        } else {
          onTime1 = moment
            .duration(onTime1)
            .asMinutes()
            .toString();
          onTime1 = Number(onTime1);
        }

        if (offTime1.length > 5) {
          offTime1 = moment.tz(offTime1, "Asia/Kolkata").format("HH:mm");
          offTime1 = moment
            .duration(offTime1)
            .asMinutes()
            .toString();
          offTime1 = Number(offTime1);
          if (offTime1 > 0) {
            offTime1 = offTime1;
          } else {
            offTime1 = offTime1;
          }
        } else {
          offTime1 = moment
            .duration(offTime1)
            .asMinutes()
            .toString();
          offTime1 = Number(offTime1);
        }

        if (stepName == "step1") {
          Relay1.push(onTime1);
          Relay1.push(offTime1);
          Relay1.push(0);
          Relay1.push(0);
        } else {
          Relay2.push(onTime1);
          Relay2.push(offTime1);
          Relay2.push(0);
          Relay2.push(0);
        }
      }

      pushDataSet(step1Data, "step1");
      pushDataSet(step2Data, "step2");
      var payload = {
        modemid: Number(this.modemId),
        schedule: {
          relay1: Relay1,
          relay2: Relay1,
          relay3: Relay2,
          relay4: Relay2
        }
      };
      console.log(payload);
      this.$http.post(this.endpoint + "/api/user_config/update", payload).then(
        response => {
          var response = response;
          this.$vs.notify({
            title: "Dimming Policy Updated",
            text: "Your Dimming Policy is successfully registered!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
        },
        error => {
          console.log(error);
          this.$vs.notify({
            title: "Error",
            text: error.response.data,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        }
      );
    }
  }
};
</script>

<style>
.vs-avatar--text {
  font-size: 1.8rem !important;
}
</style>
